import { useState } from "react";
import axios from "axios";

export default function AddProduct() {
  const sellerId = localStorage.getItem("sellerId");
  const [form, setForm] = useState({
    name: "",
    description: "",
    place: "",
    price: "",
    features: ""
  });
  const [image, setImage] = useState(null);

  const submit = async () => {
    const fd = new FormData();
    fd.append("name", form.name);
    fd.append("description", form.description);
    fd.append("place", form.place);
    fd.append("price", form.price);
    fd.append("features", form.features);
    fd.append("sellerId", sellerId);
    if (image) fd.append("image", image);

    const res = await axios.post("https://haaterkaj-backend-1.onrender.com/api/seller/add-product", fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    alert(res.data.success ? "✅ Product Added" : "❌ Failed");
  };

  return (
    <div className="max-w-lg mx-auto p-6">
      <h2 className="text-xl font-bold mb-4">Add Product</h2>

      <input className="w-full border p-2 text-black placeholder-gray-600 mb-3" placeholder="Product Name"
        onChange={e => setForm({ ...form, name: e.target.value })} />

      <textarea className="w-full border p-2 text-black placeholder-gray-600 mb-3" placeholder="Description"
        onChange={e => setForm({ ...form, description: e.target.value })}></textarea>

      <input className="w-full border p-2 text-black placeholder-gray-600 mb-3" placeholder="Place"
        onChange={e => setForm({ ...form, place: e.target.value })} />

      <input className="w-full border p-2 text-black placeholder-gray-600 mb-3" placeholder="Price"
        onChange={e => setForm({ ...form, price: e.target.value })} />

      <input className="w-full border p-2 text-black placeholder-gray-600 mb-3" placeholder="Features (comma separated)"
        onChange={e => setForm({ ...form, features: e.target.value })} />

      <input type="file" onChange={e => setImage(e.target.files[0])} className="mb-3" />

      <button onClick={submit} className="bg-amber-700 text-white px-4 py-2 rounded">
        Add Product
      </button>
    </div>
  );
}
